import { LinkType } from ".."

const disabledRedirectUrls = ["/integration"]

export const disableRedirect = (activePage: LinkType) => {
  if (disabledRedirectUrls.includes(activePage.url)) return false

  return true
}
